module.exports = __webpack_public_path__ + "static/media/home_logo_en.1952bf14.png";